export const JWT_STORAGE_KEY =
  process.env.REACT_APP_JWT_STORAGE_KEY || 'auth.token';
